import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "@/components/theme-provider";
import { Button } from "@/components/ui/button";

type Theme = "light" | "dark" | "system";

export function ModeToggle() {
    const { theme, setTheme } = useTheme();

    const cycleTheme = () => {
        const themeOrder: Theme[] = ["light", "dark", "system"];
        const currentIndex = themeOrder.indexOf(theme as Theme);
        const safeIndex = currentIndex === -1 ? 0 : currentIndex;
        const nextTheme = themeOrder[(safeIndex + 1) % themeOrder.length];
        setTheme(nextTheme);
    };

    const label =
        theme === "light" ? "Switch to dark mode" : theme === "dark" ? "Switch to system theme" : "Switch to light mode";

    return (
        <Button
            variant="outline"
            size="icon"
            onClick={cycleTheme}
            aria-label={label}
            title={label}
            className="rounded-full bg-white/50 backdrop-blur-sm border-gray-200 dark:bg-gray-800/50 dark:border-gray-700"
        >
            {theme === "dark" ? (
                <Moon className="h-[1.2rem] w-[1.2rem] text-blue-400" />
            ) : theme === "system" ? (
                <Monitor className="h-[1.2rem] w-[1.2rem] text-gray-600 dark:text-gray-300" />
            ) : (
                <Sun className="h-[1.2rem] w-[1.2rem] text-yellow-500" />
            )}
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
}
